export const SMALL_PAGE_SIZE = 5;
export const STANDARD_PAGE_SIZE = 20;
export const MAX_CHARACTERS_LIMIT_POSTS = 2500;
